import React from 'react';
import { Heart, ExternalLink } from 'lucide-react';
import { Badge } from './ui/badge';
import { googleForms } from '../mock';
import { useTranslation } from '../i18n/LanguageContext';

const GetInvolvedPage = () => {
  const { t } = useTranslation();
  const handleApplyClick = () => {
    if (googleForms.ministryApplication) {
      window.open(googleForms.ministryApplication, '_blank');
    }
  };

  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="text-white py-24 md:py-36 relative overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: "url('/images/holy-fire-bg.jpg')" }}></div>
        <div className="absolute inset-0 bg-black/40"></div>
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-4xl mx-auto text-center space-y-8 fade-in">
            <Badge variant="secondary" className="bg-white/20 text-white border-white/30 uppercase tracking-[0.3em] text-xs">
              {t('getInvolved.badge')}
            </Badge>
            <h1 className="display-hero text-4xl sm:text-5xl md:text-6xl lg:text-7xl">
              {t('getInvolved.heroTitle')} <span className="italic font-light">{t('getInvolved.heroAccent')}</span>
            </h1>
            <p className="text-lg md:text-xl text-white/85 max-w-2xl mx-auto">
              {t('getInvolved.heroSubtitle')}
            </p>
          </div>
        </div>
      </section>

      {/* Simple CTA Section */}
      <section className="py-24 md:py-32 bg-background">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center space-y-10">
            <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto">
              <Heart className="h-10 w-10 text-primary" />
            </div>
            <h2 className="display-hero text-3xl sm:text-4xl md:text-5xl lg:text-6xl">
              {t('getInvolved.readyTitle')} <span className="italic font-light text-gradient">{t('getInvolved.readyAccent')}</span>
            </h2>
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed max-w-xl mx-auto">
              {t('getInvolved.readyBody')}
            </p>
            <div className="pt-4">
              <button
                onClick={() => handleApplyClick()}
                className="learn-more text-foreground"
              >
                {t('getInvolved.openForm')}
                <ExternalLink className="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GetInvolvedPage;
